import { instance } from './axios';

export const gamesAPI = {
  stats(): Promise<any> {
    return instance.get(`games/stats`).then((response) => response.data);
  },
};
